import { Reveal } from "@/components/Reveal";

export default function FinalCta() {
  return (
    <section className="bg-safety">
      <div className="mx-auto max-w-[1160px] px-6 py-[88px] text-center">
        <Reveal>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-white leading-tight">
            Start with a $1,000 founding paid pilot.
          </h2>
        </Reveal>
        <Reveal delay={0.15}>
          <p className="mt-5 text-lg text-white/85">No install fee. Uses the cameras you already have.</p>
        </Reveal>
        <Reveal delay={0.25}>
          <a
            href="/contact?topic=pilot"
            data-testid="finalcta-pilot-button"
            className="mt-10 inline-block rounded-lg bg-navydeep text-white font-bold px-10 py-4 hover:bg-navy transition-colors"
          >
            Book a pilot
          </a>
        </Reveal>
      </div>
    </section>
  );
}
